import React, { useState } from 'react'
import { useRecoilValue } from 'recoil'
import { styled } from 'styled-components'

import { subDataState } from '@/util/states'
import { useGetPosts } from 'src/hooks/posts/useGetPosts'
import { PostList } from '../../components/Discover/PostList'

import {
  DISCOVERIES,
  FAVORITES,
  PURCHASES,
} from '@/util/constants'

export async function getStaticProps() {
  return {
    props: {
      title: 'Discover | Beyond the Pines',
      description: 'Discover exclusive content from Beyond the Pines. Browse editorials, behind the scenes, and creator posts.',
    },
  }
}

export default function Discover() {
  const subData = useRecoilValue(subDataState)
  const tabs = [DISCOVERIES]
  const [activeTab, setActiveTab] = useState(DISCOVERIES)
  const {
    posts,
    isLoading,
    hasMore,
    loadMore,
  } = useGetPosts({
    userId: null,
    orderBy: 'approvedAt',
    limit: 10,
    enablePagination: activeTab === DISCOVERIES,
  })

  if (subData === 'pending') return null

  if (subData?.unlockedDiscoveries?.length > 0) tabs.push(PURCHASES)
  if (subData?.favoritePosts) tabs.push(FAVORITES)

  let filteredPosts = posts

  if (activeTab === PURCHASES) {
    filteredPosts = posts.filter(p => subData?.unlockedDiscoveries?.includes(p.id))
  }

  if (activeTab === FAVORITES) {
    filteredPosts = posts.filter(p => subData?.favoritePosts?.includes(p.id))
  }

  return (
    <PageWrapper>
      <PostList
        posts={filteredPosts}
        unlockedList={subData.unlockedDiscoveries}
        loadMore={loadMore}
        hasMore={hasMore}
        isLoading={isLoading}
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
    </PageWrapper>
  )
}

const PageWrapper = styled.div`
  background: #fafafa;
  min-height: 100vh;
`
